const extractValidBaggageAmount = (text: string) => {
    if (!text) return false
    // Look for number + unit like 23KG, 1 Piece, etc.
    const match = text.match(/([0-9]+)\s*(KG|Kilos|Piece|Pieces|kg|kilos|piece|pieces)/i)
    if (!match) return false
    const number = parseInt(match[1])
    return number > 0
}

export const formatBaggageInfo = (baggageInfo: string, lng: string) => {
    let hasBaggageInfo = extractValidBaggageAmount(baggageInfo)
    let baggageDisplayText = ''

    if (hasBaggageInfo) {
        if (lng === 'ar') {
            baggageDisplayText = baggageInfo
                .replace(/KG|kg|Kg/, 'كجم')
                .replace(/KILOS|kilos|Kilos|KILO|kilo|Kilo/, 'كيلو')
                .replace(/PIECE|piece|Piece|PIECES|pieces|Pieces/, 'قِطَع')
                .replace(/ADULT|adult|Adult/, 'بالغ')
                .replace(/CHILD|child|Child/, 'طفل')
                .replace(/INFANT|infant|Infant/, 'رضيع')
                .replace(/\s*[xX]\s*/g, ' × ')

            return baggageDisplayText
        } else {
            return baggageInfo
        }
    } else {
        return ''
    }
}
